import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getWhiteboardRecordingsList, getSubjects, getFacultyList, getWhiteboardRecording } from '../../Redux/ActionCreators/myLearningAction';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table';
import { TopicLoader } from '../../Loader/loader';
import "./MyClassNotes.scss";
import ViewResource from '../../utils/viewResource';
import MediaPlayer from '../../utils/mediaPlayer';

export default function MyClassNotes() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [recordingurl, setRecordingurl] = useState('');
    const { whiteboardRecordingsList, isRecordingListLoading, subject, facultyList, whiteboardRecording } = useSelector((state) => state.myLearning);
    const [subject_id, setSubject_id] = useState('');
    const [chapter_id, setChapter_id] = useState('');
    const [user_id, setUser_id] = useState('');
    const [resource, setResource] = useState(null);
    const [isView, setIsView] = useState(false);

    useEffect(() => {
        const firstRender = async () => {
            const classroomId = localStorage.getItem('classroomId');
            await dispatch(getWhiteboardRecordingsList(subject_id, chapter_id, user_id));
            classroomId && await dispatch(getSubjects(classroomId));
            await dispatch(getFacultyList());
        }
        firstRender();
    }, [])

    const openView = async (el) => {
        setIsView(true);
        setResource(el);
        await dispatch(getWhiteboardRecording(el._id));
    }

    const closeDetails = () => {
        setIsView(false);
    }

    return (
        <div className="class-notes-list">
            <div className="d-flex justify-content-between" >
                <div>
                    <h3>{t('Class Notes')}</h3>
                    <p className='pt-desc'>Access your teacher class notes to help you review key concepts and prepare for upcoming exams.</p>
                </div>
                {whiteboardRecordingsList && whiteboardRecordingsList.length > 0  && <div className="header-filters">
                    <label>{t('Filter by Teacher')}</label>
                    <select onChange={(e) => {
                        setUser_id(e.target.value);
                        dispatch(getWhiteboardRecordingsList(subject_id, chapter_id, e.target.value));
                    }}>
                        <option value="">All</option>
                        {
                            facultyList && facultyList.map((el, index) => {
                                return (
                                    <option key={index} value={el._id}>{el.name}</option>
                                )
                            })
                        }
                    </select>
                </div>}
                <div className="header-filters">
                    <label>{t('Filter by Subject')}</label>
                    <select onChange={(e) => {
                        setSubject_id(e.target.value);
                        dispatch(getWhiteboardRecordingsList(e.target.value, chapter_id, user_id));
                    }}>
                        <option value="">All</option>
                        {
                            subject.map((el, index) => {
                                return (
                                    <option key={index} value={el._id}>{el.name}</option>
                                )
                            })
                        }
                    </select>
                </div>
            </div>

            <div className="class-notes-table">
                <ul>
                {
                    window.innerWidth > 767 ? (
                        <div className="table-admin">
                            <Table responsive>
                                <thead>
                                    <tr id="picksHeading" className="header-table">
                                        <th className="text-center">{t('Title')}</th>
                                        <th className="text-center">{t('Subject')}</th>
                                        <th className="text-center">{t('Topic')}</th>
                                        <th className="text-center">{t('Recorded By')}</th>
                                        <th className="text-center">{t('Type')}</th>
                                        <th className="text-center">{t('Action')}</th>
                                    </tr>
                                </thead>

                                <tbody className="table-body">
                                    {isRecordingListLoading ?
                                        <tr>
                                            <td colSpan={5}>
                                                <TopicLoader />
                                            </td>
                                        </tr> :
                                        whiteboardRecordingsList !== undefined && whiteboardRecordingsList.length > 0 ? (
                                            whiteboardRecordingsList.map((el, index) => {

                                                return (
                                                    <tr key={el._id}>
                                                        <td style={{ width: "30%" }}>{el.title}</td>
                                                        <td className="text-center">
                                                            {el.subject_id?.name}
                                                        </td>
                                                        <td className="text-center">
                                                            {el.chapter_id?.name}
                                                        </td>
                                                        <td className="text-center">
                                                            {el.user_id?.firstname + ' ' + el.user_id?.lastname}
                                                        </td>
                                                        <td className="text-center">
                                                            {el.type}
                                                        </td>
                                                        <td className="text-center" >
                                                            <button className="start-test" onClick={() => {
                                                                setRecordingurl(el.url);
                                                                openView(el)
                                                            }
                                                            }>{t('View')}</button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr style={{ borderTop: "35px solid #F7F7FA" }}>
                                                <td colSpan={5}>
                                                    <div className="empty-list">
                                                        <img src="/images/empty.png" alt="" />
                                                    </div>
                                                    <p>{t('No Recordings Found')}</p>
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </Table>
                            {/* <div className="resource-details" style={{ display: isView ? 'block' : 'none', }}>
                                <ViewResource
                                    activeFeedData={resource}
                                    closeNotes={closeDetails}
                                />
                            </div> */}
                            {isView && (
                                <div className="popup-overlay" style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0,0,0,0.85)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: 1000,
                                    padding: '20px'
                                }}>
                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '0px 30px 30px 30px',
                                        borderRadius: '12px',
                                        width: '95%',
                                        height: '90vh',
                                        maxWidth: '1400px',
                                        overflow: 'auto',
                                        position: 'relative',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '20px',
                                            borderBottom: '1px solid #eee',
                                            position: 'sticky',
                                            top: 0,
                                            backgroundColor: 'white',
                                            zIndex: 1
                                        }}>
                                            <h3 style={{
                                                margin: 0,
                                                fontSize: '20px',
                                                fontWeight: 600,
                                                color: '#333',
                                                marginTop: '30px'
                                            }}>
                                                {resource.title || 'Resource Viewer'}
                                            </h3>
                                            <button 
                                                onClick={closeDetails}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    fontSize: '24px',
                                                    cursor: 'pointer',
                                                    color: '#666',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    transition: 'all 0.2s',
                                                    lineHeight: 1
                                                }}
                                                onMouseOver={(e) => e.currentTarget.style.color = '#000'}
                                                onMouseOut={(e) => e.currentTarget.style.color = '#666'}
                                            >
                                                ×
                                            </button>
                                        </div>
                                        {resource.type === 'image' && (
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '80%',
                                                width: '100%',
                                                overflow: 'auto'
                                            }}>
                                                <MediaPlayer 
                                                    activeFeedData={resource}
                                                    width="90%"
                                                    height={"90%"}
                                                    key={resource.url}
                                                    isView={true}
                                                />
                                            </div>
                                        )}
                                        {resource.type === 'video' && (
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '80%',
                                                width: '100%',
                                                backgroundColor: '#000',
                                                position: 'relative'
                                            }}>
                                                <MediaPlayer 
                                                    activeFeedData={resource}
                                                    autoPlay={true}
                                                    controls={true}
                                                    width="90%"
                                                    height={"90%"}
                                                    key={resource.url}
                                                    isView={true}
                                                />
                                            </div>
                                        )}
                                        {/* <div style={{
                                            marginTop: '20px',
                                            width: '100%',
                                            padding: '15px',
                                            borderRadius: '8px',
                                            boxSizing: 'border-box'
                                        }}>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                color: '#ff8c00',
                                                fontWeight: '500',
                                                fontSize: '16px'
                                            }}>Your notes</label>
                                            <textarea
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    borderRadius: '6px',
                                                    border: '2px solid #ffa500',
                                                    fontFamily: 'inherit',
                                                    fontSize: '14px',
                                                    lineHeight: '1.5',
                                                    color: '#333',
                                                    backgroundColor: '#fff',
                                                    transition: 'border-color 0.3s ease',
                                                    resize: 'vertical',
                                                    minHeight: '100px',
                                                    outline: 'none'
                                                }}
                                                rows="3" 
                                                value={resource?.note}
                                                // onChange={(e) => this.changeNotes(e)}
                                                // maxLength={this.state.limWords}
                                                placeholder='Enter your notes here'
                                                id='note'
                                                onFocus={(e) => e.target.style.borderColor = '#ff8c00'}
                                                onBlur={(e) => e.target.style.borderColor = '#ffa500'}
                                            />
                                        </div> */}
                                    </div>
                                    
                                </div>
                            )}
                        </div>
                    ) : null}
                </ul>
            </div>
        </div>
    )
}